import * as React from 'react'
import * as domain from '@packages/domain'
import { identity, O, pipe, s } from '@packages/prelude'
import { Matomo } from '../commons'

export const ListAd: React.VFC<domain.Ad.Type> = ({ image, url, matomoId: _matomoId }) => {
  const ref = React.useRef(null)
  const matomoId = pipe(_matomoId, O.foldMap(s.Monoid)(identity))

  React.useEffect(() => {
    pipe(
      ref.current,
      O.fromNullable,
      O.map(() => pipe(['trackContentImpression', matomoId, 'preview', url], Matomo.configure(window)))
    )
  }, [ref, matomoId, url])

  const onClick = React.useCallback(() => {
    pipe(
      ref.current,
      O.fromNullable,
      O.map(() => pipe(['trackContentInteraction', 'click', matomoId, 'preview', url], Matomo.configure(window)))
    )
  }, [ref, matomoId, url])

  return (
    <div className="row post-preview post-preview-row" ref={ref}>
      <div className="col-sm-10 offset-lg-1">
        <a href={url} className="ad" target="_blank" rel="noreferrer" onClick={onClick}>
          <img src={image.url} alt="werbung" className="w-100" />
        </a>
      </div>
    </div>
  )
}
